<template>
  <div class="layout-view">
    <el-container>
      <!-- 左侧 -->
      <el-aside :width="isCollapse ? '66px' : '202px'" class="layout-aside">
        <layout-aside :is-collapse="isCollapse"></layout-aside>
      </el-aside>
      <!-- 右侧 -->
      <el-container class="layout-right">
        <!-- 上侧 -->
        <el-header height="55px" class="layout-header">
          <layout-header :is-collapse="isCollapse" @toggle-collapse="isCollapse = !isCollapse"></layout-header>
        </el-header>
        <!-- 面包屑导航 -->
        <div class="layout-breadcrumb" v-if="breadcrumbList.length">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">
              {{ item }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 下侧 -->
        <el-main class="layout-main">
          <slot name="main">
            <router-view></router-view>
          </slot>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import LayoutAside from './components/LayoutAside.vue'
import LayoutHeader from './components/LayoutHeader.vue'

export default {
  name: 'MainLayout',
  components: {
    LayoutAside,
    LayoutHeader
  },
  data() {
    return {
      isCollapse: false
    }
  },
  computed: {
    // 面包屑：直接读取路由 meta.breadcrumb（动态路由生成时已预计算好父级链）
    // 首页是静态路由，单独返回
    breadcrumbList() {
      return this.$route.meta && this.$route.meta.breadcrumb || []
    }
  }
}
</script>

<style lang="less" scoped>
.layout-view {
  width: 100%;
  height: 100%;
  background-color: #021633;

  .el-container {
    height: 100%;
  }

  .layout-aside {
    transition: width 0.3s ease;
  }

  .layout-aside,
  .layout-header,
  .layout-main {
    background-color: #011E4A;
    border: 1px solid #024366;
  }

  .layout-main {
    margin: 16px;
    overflow-y: auto;
    scroll-behavior: smooth;
  }

  .layout-breadcrumb {
    margin-top: 16px;
    margin-left: 16px;
  }
}
</style>